document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".js-toggle-measurement");
  const sizeTable = document.querySelector("#size-chart table");

  // Only proceed if size table exists
  if (!sizeTable) {
    return;
  }

  // Store original inch values and round display on load
  sizeTable.querySelectorAll("tr").forEach(row => {
    const cells = row.querySelectorAll("td");
    cells.forEach((cell, index) => {
      if (index === 0) return; // Skip label column
      const val = parseFloat(cell.textContent);
      if (!isNaN(val)) {
        const roundedInches = Math.round(val);
        cell.setAttribute("data-inches", roundedInches);
        cell.textContent = roundedInches;
      }
    });
  });

  // Default active state to Inches button
  buttons.forEach(btn => btn.setAttribute("data-active", "false"));
  if (buttons.length) {
    buttons[0].setAttribute("data-active", "true");
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      const selectedUnit = this.getAttribute("data-val");

      // Toggle active button
      buttons.forEach(btn => btn.setAttribute("data-active", "false"));
      this.setAttribute("data-active", "true");

      // Convert table values based on original inches
      sizeTable.querySelectorAll("tr").forEach(row => {
        const cells = row.querySelectorAll("td");
        cells.forEach((cell, index) => {
          if (index === 0) return;
          const inchVal = parseFloat(cell.getAttribute("data-inches"));
          if (isNaN(inchVal)) return;

          if (selectedUnit === "cms") {
            cell.textContent = Math.round(inchVal * 2.54);
          } else if (selectedUnit === "inches") {
            cell.textContent = Math.round(inchVal);
          }
        });
      });
    });
  });
});

// FAQ accordion (.stampd-faq) — the widget markup lives in page body content,
// where Shopify's rich-text editor strips inline <script> tags, so the toggle
// behavior is wired up here instead. Event-delegated so it works regardless of
// when the content renders.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".stampd-faq .sfaq-q").forEach(button => {
    const item = button.closest(".sfaq-item");
    if (!item) return;
    button.setAttribute("aria-expanded", item.classList.contains("open") ? "true" : "false");
  });

  document.addEventListener("click", function (event) {
    const button = event.target.closest(".stampd-faq .sfaq-q");
    if (!button) return;

    const item = button.closest(".sfaq-item");
    if (!item) return;

    const isOpen = item.classList.toggle("open");
    button.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });
});